export default __webpack_public_path__ + "marker.21ec549bbfa924c3cf26ea60d7673f81.png";